import React from 'react';
import { Layout, Menu, Dropdown, Button, Row, Col, Typography, Card, Divider } from 'antd';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import '../App.css'; // Add your custom CSS styles here
import logo from '../images/Aptean Logo - Black.svg';
import ManagerDetail from './ManagerDetail';
import ListOfEmployee from './ListOfEmployee';
import NineBoxPage from './NineBoxPage';
import { AppProvider, useAppContext } from './AppContext';
import EmployeeTree from './EmployeeHierarchy';
import TeamSummary from './TeamSize';
import { useEffect, useState } from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';


const { Header, Content, Sider } = Layout;
const { Title } = Typography;
const { SubMenu } = Menu;


const AppLayout = () => {

  const [graphData, setGraphData] = useState(null);
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  const { upName, setUpName } = useAppContext();
  const { mailID, setMailID } = useAppContext();
  const { tableData, setTableData } = useAppContext();
  const { filteredTableData, setFilteredTableData } = useAppContext();
  const { accessToken, updateUserPrincipalName, setAccessToken, updateMailID } = useAppContext();
  const { setLoggedInMail, setLoggedInUPN } = useAppContext();
  const { setLoggedInName } = useAppContext();

  // Replace these with your actual user data
  const userProfile = {
    username: graphData?.displayName,
    // avatar: 'https://placekitten.com/40/40', // URL to user's avatar
  };

  const colStyle = {
    border: '1px solid #ddd', // Set the border style
    padding: '20px', // Add padding for spacing inside the form
  };

  const handleSignOut = () => {
    instance.logoutRedirect();
  }

  const menu = (
    <Menu onClick={handleSignOut}>
      <Menu.Item key="1" icon={<LogoutOutlined />}>
        Logout
      </Menu.Item>
    </Menu>
  );




  const fetchData = async () => {
    try {
      const response = await fetch('https://graph.microsoft.com/v1.0/me', {
        headers: {
          'Authorization': `Bearer ${accessToken}`
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }

      const data = await response.json();
      //console.log('Data:', data);
      setGraphData(data);
      setUpName(data.userPrincipalName);
      setMailID(data.mail);
      setLoggedInMail(data.mail);
      setLoggedInUPN(data.userPrincipalName);
      setLoggedInName(data.displayName);

      //console.log('User Principal Name:', upName);

      // Process the data as needed
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    if (!isAuthenticated) {
      console.error('User is not authenticated');
      navigate('/');
    }

    //console.log('Access Token from context: ', accessToken);

    fetchData();

  }, [accessToken]);

  return (
    <Layout style={{ minHeight: '100vh' }}>

      <Layout>

        <Header style={{ background: 'white', padding: '0 16px' }}>
          <Row align="middle">
            <Col >
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <img src={logo} alt="Logo" style={{ height: '40px', width: '80px', margin: 5 }} />
                <Divider type="vertical" style={{ height: '40px', width: '2px', color: 'black', backgroundColor: 'lightgrey', marginLeft: 10, marginTop: 7, marginRight: 10 }} />
                <Title style={{ marginTop: 12, color: 'black', fontFamily: 'unset', fontSize: 20 }}>
                  Aptean Talent Review
                </Title>
              </div>
            </Col>
            <Col>

            </Col>
            <Col flex="auto" style={{ textAlign: 'left' }}>

            </Col>
            <Col>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Dropdown overlay={menu} placement="middleRight" arrow>
                  <Button type="text" style={{ marginLeft: 8, marginBottom: 10, color: 'black', marginTop: 10 }}>
                    {userProfile.username} <UserOutlined />
                  </Button>
                </Dropdown>
              </div>
            </Col>
          </Row>

        </Header>
        <Content >
          {/* <AppProvider> */}
          <Layout style={{ margin: 10 }}>
            <Content  >
              <Row>
                <Col>
                  <EmployeeTree clickable />
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col span={8}>
                  <Card style={{ display: 'flex', alignItems: 'center' }}>
                    <div >
                      <ManagerDetail />
                    </div>
                    <div >
                      <TeamSummary />
                    </div>
                  </Card>
                </Col>

                <Col span={16}>
                  <Card >

                    <div style={{ padding: '10px', display: 'flex', justifyContent: 'space-around' }}>
                      <NineBoxPage />
                    </div>
                  </Card>
                </Col>
              </Row>
            </Content>

          </Layout>
          <Layout style={{ margin: 10 }}>
            <ListOfEmployee />
          </Layout>
          {/* </AppProvider> */}

        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
